export default __webpack_public_path__ + "static/media/warningIcon.92315ee3.svg";